









import { Vue, Component } from 'vue-property-decorator'
import { TitleBlockModel } from '../models'
import TitleBlock from '@/components/TitleBlock.vue'
import ItemsAdv from '@/components/ItemsAdv.vue'

@Component({
  components: {
    TitleBlock,
    ItemsAdv
  }
})

export default class BlockAdv extends Vue {
  titles: TitleBlockModel = {
    title: 'Преимущества',
    subtitle: 'Преимущества и возможности, за которые нас любят наши пользователи'
  }
}
